import React from 'react';
import { UserProfileEditTemplate } from 'themes/application/user/pages';
import { observer } from 'mobx-react';
import { UserEditViewStore } from 'application/user/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new UserEditViewStore(rootStore), 'userEditViewStore')
@observer
class UserProfileEdit extends React.Component {
    render() {
        return <UserProfileEditTemplate {...this.props} />
    }
}

export default UserProfileEdit;
